export default __webpack_public_path__ + "static/media/HuisGenoot.31b9794e.png";